// BHP-1044: quote server-state via React Query (replaces quoteReducer's list fetch).
// Kept lean per KISS/YAGNI: the hook calls QuoteService directly. A domain port +
// adapter (like features/vps) is only worth introducing when the backend is
// actually swapped (API-1/Backend2.0).
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import QuoteService from '../../../Services/QuoteService';
import type QuoteData from '../../../Models/QuoteData';

const quoteService = new QuoteService();

export const quoteKeys = {
  all: ['quotes'] as const,
  recent: () => [...quoteKeys.all, 'recent'] as const
};

/** Quotes of the active customer, filtered to the last 3 months. */
export function useRecentQuotes(): UseQueryResult<QuoteData[]> {
  return useQuery({
    queryKey: quoteKeys.recent(),
    queryFn: async () => {
      const quotes = await quoteService.getQuotesFromCustomer();
      return await quoteService.filterRecentQuote(quotes);
    }
  });
}
